export const DEFAULT_COUNTRY_CODE = 'PY';
export const DEFAULT_CURRENCY_CODE = 'PYG';
export const DEFAULT_LOCALE = 'es-PY';
export const DEFAULT_TIMEZONE = 'America/Asuncion';

export const DOLAR_COUNTRY_CODE = 'US';
export const DOLAR_CURRENCY_CODE = 'USD';
export const DOLAR_LOCALE = 'en-US';

export const REAL_COUNTRY_CODE = 'BR';
export const REAL_CURRENCY_CODE = 'BRL';
export const REAL_LOCALE = 'pt-BR';